import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Button from '../../../components/form/button/Button';
import Icon from '../../../components/icon/Icon';
import DeliveryZoneCard from './DeliveryZoneCard.tsx/DeliveryZoneCard';
import { RootState } from '../../../core/state/state';
import { getDeliveryZones, getMeansOfTransport } from '../../../core/state/zones/asyncActions';
import ManageDeliveryZoneModal from '../modals/manage-delivery-zone/ManageDeliveryZoneModal';
import { isReadAllRole } from '../../../core/state/user/selectors';

import './DeliveryZones.scss';

const DeliveryZones: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUserReader = useSelector(isReadAllRole);

  const { deliveryZones } = useSelector((state: RootState) => state.zones);

  React.useEffect(() => {
    dispatch(getDeliveryZones(Number(projectId)));
    dispatch(getMeansOfTransport());
  }, [dispatch, projectId]);

  return (
    <div className="delivery-zones">
      {!isUserReader && (!deliveryZones || (deliveryZones && deliveryZones.length < 15)) ? (
        <div className="delivery-zones__new-zone">
          <Button onClick={() => setIsModalOpen(true)} buttonTypes={['blue', 'extra-small']}>
            <Icon className="delivery-zones__new-zone-icon" icon="plus" size="extra-small" svg />
          </Button>
          <span className="delivery-zones__new-zone-text">{t('projectSettings.deliveryZones.new')}</span>
        </div>
      ) : null}
      {deliveryZones && deliveryZones.map((item, i) => <DeliveryZoneCard key={item.id} order={i + 1} zone={item} />)}
      {isModalOpen && (
        <ManageDeliveryZoneModal
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          order={(deliveryZones && deliveryZones?.length + 1) ?? 1}
        />
      )}
    </div>
  );
};

export default DeliveryZones;
